import {refetchXsrfCookie} from "../utils";

export default {

    getLoggedInUser: function() {
        /* This doesn't work at the moment, endpoint is missing */
        return axios.get('/user');
    },

    getEmailExists: function(email) {
        return axios.get('/api/search/user/email?q=' + encodeURIComponent(email)).catch(function(error) {
            let newError = new Error("User Email Check Failed, ") + error;
            throw newError;
        });
    },

    getCgrUserHasDisplayNameByEmail: function(email) {
        return axios.get('/api/search/user/display_name/cgr?q=' + encodeURIComponent(email)).catch(function(error) {
            let newError = new Error("Cgr User Check Failed, ") + error;
            throw newError;
        });
    },

    getDisplayNameExists: function(name) {
        return axios.get('/api/search/user/display_name?q=' + encodeURIComponent(name)).catch(function(error) {
            let newError = new Error("Display Name Check Failed, ") + error;
            throw newError;
        });
    },

    postUser: function(data) {
        return axios.post('/api/register', data).catch(function(error) {
           let newError = new Error("User Register Failed, ") + error;
           throw newError;
        });
    },

    updateUser: function(data) {
        axios.interceptors.response.use(response => response, refetchXsrfCookie)
        return axios.put('/api/user', data);
    },

    updateOrCreateCgrUser: function(data) {
        return axios.put('/api/user/cgr', data);
    },

    postValidateCredentials: function (email, password, oauthClientId) {
        let data = {email: email, password: password, oauth_client_id: oauthClientId};
        console.log('postValidateCredentials Email: ', email);

        return axios.post('/api/login/validate', data);
    },
}
